module.exports = __webpack_public_path__ + "img/code-sandbox.710be4b6.svg";